/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface LicensingEnrollment
 */
export interface LicensingEnrollment {
  /**
   * The unique identifier of the student.
   * @type number
   * @memberof LicensingEnrollment
   */
  studentKey: number
  /**
   * The unique identifier of the program the family has students enrolled in.
   * @type number
   * @memberof LicensingEnrollment
   */
  programKey: number
  /**
   * Describes the semester to which the payment is to be charged.
   * @type string
   * @memberof LicensingEnrollment
   */
  feeTypeKey: LicensingEnrollmentFeeTypeKeyEnum
}

/**
 * @export
 * @enum {string}
 */
export enum LicensingEnrollmentFeeTypeKeyEnum {
  SemesterOneLicensingFee = 'semesterOneLicensingFee',
  SemesterTwoLicensingFee = 'semesterTwoLicensingFee',
}

export function LicensingEnrollmentFromJSON(json: any): LicensingEnrollment {
  return LicensingEnrollmentFromJSONTyped(json, false)
}

export function LicensingEnrollmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LicensingEnrollment {
  if (json === undefined || json === null) {
    return json
  }
  return {
    studentKey: json['studentKey'],
    programKey: json['programKey'],
    feeTypeKey: json['feeTypeKey'],
  }
}

export function LicensingEnrollmentToJSON(
  value?: LicensingEnrollment | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    studentKey: value.studentKey,
    programKey: value.programKey,
    feeTypeKey: value.feeTypeKey,
  }
}
